@if (
  {
    members: membersPerPage ?? [],
    loading: membersLoading,
    search: (searchString$ | async),
    selected: (temporalSelectedMembersList$ | async) ?? [],
    total: membersTotal ?? 0,
  };
  as vm
) {
  <div class="principal-object-list">
    <div class="container-split">
      <div class="principals-grid">
        <sui-toolbar>
          <app-search-input
            [placeholder]="'feed-actions.placeholder.search' | translate"
            (inputChanged)="handleInputPrincipalSearchChange($event)"
          ></app-search-input>
          @if (!singleSelectionActive) {
            <sui-checkbox
              [checked]="selectAllChecked"
              (checkedChange)="onSelectAllChange($event)"
            >
              {{ "object-picker-actions.button.select-all" | translate }}
            </sui-checkbox>
          }
        </sui-toolbar>
        <div class="card-container mb-containers principals">
          @if (vm.loading) {
            <app-loading></app-loading>
          } @else {
            @if (vm.members.length === 0) {
              <div>
                {{ "principal-list.message.no-principals" | translate }}
              </div>
            }
            @if (vm.members.length > 0) {
              @for (
                object of vm.members;
                track trackByPrincipalId($index, object)
              ) {
                <app-principal-card
                  (onObjectSelect)="toggleSelection($event)"
                  [selected]="isSelected(object)"
                  [highlightText]="vm.search"
                  [principal]="object"
                ></app-principal-card>
              }
            }
          }
        </div>
      </div>
      <div class="selected-principals">
        <div class="title">
          <span>
            {{ "principal-list.title.selected" | translate }} ({{
              principalSelectedCount
            }})
          </span>
          @if (principalSelectedCount > 0) {
            <sui-button
              size="sm"
              variant="secondary"
              [leadingIcon]="['fas', 'times']"
              (click)="clearSelection()"
            >
              {{ "principal-list.button.clear" | translate }}
            </sui-button>
          }
        </div>
        <div class="scrollable-content">
          @if (vm.selected.length === 0) {
            <div class="no-selected-message">
              {{ "principal-list.message.no-selected-principals" | translate }}
            </div>
          }
          @for (
            principal of vm.selected;
            track trackByPrincipalId($index, principal)
          ) {
            <app-principal-card
              [selected]="true"
              (onObjectSelect)="toggleSelection($event)"
              [principal]="principal"
              [highlightText]="vm.search"
            ></app-principal-card>
          }
        </div>
      </div>
    </div>
    <!-- Pagination Control -->
    <div class="paging">
      <sui-pagination
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [collectionSize]="vm.total"
        (pageChanged)="onPageChange($event)"
        (doPageChange)="onPageChange($event)"
      ></sui-pagination>
    </div>
  </div>
}
